import React, { Component } from 'react';
import 'HELPDESK/Components/QueryDetails/ViewRequestModal/ClientResponse/clientresponse.css';
import HelpdeskApiCall from 'HelpdeskApiCall';
import executiveResponseGif from 'HELPDESK/CommonResources/images/executiveReponse.gif'
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class ClientResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientResponseFetching: false,
      currentRequestId: this.props.currentQueryRequestId,
      currentClientResponse: this.props.currentClientResponse,
      viewAttachment: false,
      attachmentPath: '',
      attachmentFile: '',
      attachmentFileExtension: '',
      // declare above 3 states
    }
  }


  returnViewAttachment = () => {
    let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
    return (
      <div className={this.state.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer">

        <div className="modal-dialog modal-dialog-centered modal-xl viewAttachmentDialog">
          <div className="modal-content viewAttachmentContent">
            <div className="modal-header">
              <div className="icon-container">
                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
              </div>
              <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</h3>
              <FontAwesomeIcon
                icon={['fas', 'times']}
                style={{ cursor: 'pointer' }}
                size="lg"
                color="#000000"
                onClick={() => this.setState({ viewAttachment: false })} // Close the modal
              />
            </div>
            <div className="modal-body viewAttachment-body">
              {
                imageExtensions.includes(this.state.attachmentFileExtension) ?
                  <div>
                    <img src={this.state.attachmentPath + '/' + this.state.attachmentFile} alt='attachmentimg' width='100%' height='100%' />
                  </div>
                  :
                  <iframe title='attachmentPath' src={this.state.attachmentPath + '/' + this.state.attachmentFile} alt="attachment" width='100%' height='100%' />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
  handleAttachmentClick = (attachment, filePath) => {


    this.setState({
      viewAttachment: true,
      attachmentPath: filePath,
      attachmentFile: attachment?.fileName,
      attachmentFileExtension: attachment?.fileName.substring(attachment?.fileName.lastIndexOf('.') + 1)
    })

  };
  render() {
    return (
      <>
        <div>
          {/* <p>hello</p> */}
          {/* I will Call based on Service Request if Executive Response found then i will render that Executive Response othrwise I will give Add Response Button  along with gif to AddExecutiveResponse */}
          {Object.keys(this.props.currentClientResponse).length > 0 ? (
            // Map it
            Object.values(this.props.currentClientResponse).map(response => (
              <div className='ClientResponseContainer'>
                {/* Designing Client Response */}
                {/* <h2>{this.state.clientResponse.ServiceRequestTitle}</h2> */}
                <div className='section-title'>
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Service Request Title</p>
                  <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response.querySubject}</p>
                </div>
                <div className='customization-type'>
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Product Customization Type</p>
                 <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response.queryType ? response.queryType.charAt(0).toUpperCase() + response.queryType.slice(1) : ''}</p> 
                </div>
                <div className='client-description'>
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Description</p>
                  <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response.queryDescription}</p>
                </div>

                {response?.moduleName &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Module Name</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.moduleName}</p>
                  </div>
                }
                {/* If exsits then only show */}
                {response?.subModuleName &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Sub ModuleName</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.subModuleName}</p>
                  </div>
                }



                {
                  response?.queryOccurredIn &&
                  <div className='client-location'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Application Type</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.queryOccurredIn}</p>
                  </div>
                }

                {
                  (response?.targetedElements?.length > 0 && response?.targetedElements[0] !== "") &&
                  <div className="client-description">
                    <p className='vm_custom_body5 mb-1' style={{ color: '#000000' }}>Target Element </p>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",  // Ensures 4 elements per row
                      gap: "10px",
                      width: "100%"
                    }}>
                      {
                        response?.targetedElements?.map((element, index) => (
                          <p key={index} className='vm_custom_body6'
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '50px',
                              padding: '2px 10px',
                              cursor: 'pointer',
                              backgroundColor: '#F1F1F1',
                              width: "100%",
                              textAlign: "center"
                            }} >
                            {element}
                          </p>
                        ))
                      }
                    </div>

                  </div>
                }
                {/* desiredFeature  it is in string if present then only show and not qual to emty 
                       */}
                {/* If exsits then only show */}
                {/* accountType
                 */}
                {response?.accountType && response?.accountType.trim().length !== 0 &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Account Type</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.accountType}</p>
                  </div>
                }

                {
                  (response?.currentFeature && response?.currentFeature.trim().length !== 0) &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Current Feature</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.currentFeature}</p>
                  </div>

                }
                {
                  response?.desiredFeature && response?.desiredFeature.trim().length !== 0 &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Desired Feature</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.desiredFeature}</p>
                  </div>

                }
                {/* purpose */}

                {
                  response?.purpose && response?.purpose.trim().length !== 0 &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Purpose</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{response?.purpose}</p>
                  </div>

                }

                {
                  response?.attachments?.length > 0 &&
                  <div>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Attachments</p>
                    <div className="client-attachments">
                      <div style={{ display: "flex", gap: "10px", flexDirection: 'column' }}>
                        {
                          response.attachments?.map((attachment, index) => {

                            return (
                              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <p className='vm_custom_body8' style={{ display: 'flex', width: 'auto', borderRadius: '50px', padding: '4px 10px', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: '#F1F1F1' }} onClick={() => this.handleAttachmentClick(attachment, response.attachmentPath)}>
                                  {attachment?.fileName}
                                </p>
                                {attachment?.errorLocation !== "" &&
                                  <span className='vm_custom_body10' style={{ color: '#808080' }}>Location :  <span className='vm_custom_body8' style={{ color: '#0465ac',textDecoration:'underline' }} > {attachment?.errorLocation}</span></span>
                                }

                              </div>

                            );
                          })
                        }
                      </div>

                    </div>
                  </div>
                }



              </div>





            )




            )) : (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '5px', flexDirection: 'column' }}>
              <img src={executiveResponseGif} alt="executiveResponseGif" />
              <button className='executive-custom-button executive-assign-btn '>Client Response Loading</button>

            </div>
          )
          }


        </div>
        {/* Render the modal conditionally */}
        {this.state.viewAttachment && this.returnViewAttachment()}
      </>


    )
  }
}

export default ClientResponse
